import { render, staticRenderFns } from "./EmailValidationIframeModal.vue?vue&type=template&id=07f0477c&scoped=true&"
import script from "./EmailValidationIframeModal.vue?vue&type=script&lang=ts&"
export * from "./EmailValidationIframeModal.vue?vue&type=script&lang=ts&"
import style0 from "./EmailValidationIframeModal.vue?vue&type=style&index=0&id=07f0477c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f0477c",
  null
  
)

export default component.exports